import { render, staticRenderFns } from "./publish-article-dialog.vue?vue&type=template&id=0eccead3&scoped=true&"
import script from "./publish-article-dialog.vue?vue&type=script&lang=js&"
export * from "./publish-article-dialog.vue?vue&type=script&lang=js&"
import style0 from "./publish-article-dialog.vue?vue&type=style&index=0&id=0eccead3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eccead3",
  null
  
)

export default component.exports